<template>
  <div class="hello">
    <div  class="head">
      <i @click="goIndex()" :size="20" class="el-icon-s-home"></i>

   <img class="logo1" src="../../image/logo1.png" alt="" srcset="">
<i @click="openFullScreen1"
    v-loading.fullscreen.lock="fullscreenLoading" class="el-icon-menu"></i>

    </div>


 

    <div ref="ads1" class="ads"></div>


<div style="   background: rgb(137 124 139);
    padding: 7px;
    border-radius: 12px;
    margin: 10px;
">


    <div class="gameList">
      <div class="game_itme">
        <div class="game_itme_url" >
            <img @click="goDetail(gameList1[0])" :src="gameList1[0].game_img" alt="" srcset="">
        </div>
      </div>
      <div class="game_itme1">
                  <div class="game_itme_url2" >
            <img @click="goDetail(gameList1[1])" :src="gameList1[1].game_img" alt="" srcset="">
            <img @click="goDetail(gameList1[2])" :src="gameList1[2].game_img" alt="" srcset="">
        </div>
      </div>
    </div>
    <div class="gameList_te">
      <div   class="game_itme">
        <div  class="game_itme_url" >
            <img @click="goDetail(gameList1[3])" :src="gameList1[3].game_img" alt="" srcset="">
        </div>
      </div>
            <div   class="game_itme">
            <div  class="game_itme_url" >
            <img @click="goDetail(gameList1[4])" :src="gameList1[4].game_img" alt="" srcset="">
        </div>
      </div>
             <div   class="game_itme">
            <div  class="game_itme_url" >
            <img @click="goDetail(gameList1[5])" :src="gameList1[5].game_img" alt="" srcset="">
        </div>
      </div>
    </div>

</div>


     <div ref="ads2" class="ads"></div>


<div style=" background: rgb(137 124 139);
    padding: 7px;
    border-radius: 12px;
    margin: 10px;
">


    <div class="gameList_te">
      <div   class="game_itme">
        <div  class="game_itme_url" >
            <img @click="goDetail(gameList1[6])" :src="gameList1[6].game_img" alt="" srcset="">
        </div>
      </div>
            <div   class="game_itme">
            <div  class="game_itme_url" >
            <img @click="goDetail(gameList1[7])" :src="gameList1[7].game_img" alt="" srcset="">
        </div>
      </div>
             <div   class="game_itme">
            <div  class="game_itme_url" >
            <img @click="goDetail(gameList1[8])" :src="gameList1[8].game_img" alt="" srcset="">
        </div>
      </div>
    </div>
   <div class="gameList">
      <div class="game_itme">
        <div class="game_itme_url" >
            <img @click="goDetail(gameList1[3])" :src="gameList1[3].game_img" alt="" srcset="">
        </div>
      </div>
      <div class="game_itme1">
                  <div class="game_itme_url2" >
            <img @click="goDetail(gameList1[5])" :src="gameList1[5].game_img" alt="" srcset="">
            <img @click="goDetail(gameList1[4])" :src="gameList1[2].game_img" alt="" srcset="">
        </div>
      </div>
    </div>
    </div>
    
  <div class="ads anchor" ref="anchor"></div>


<div class="About">
  <h2>About Us</h2>
<p>Welcome to velvetvictory.site! velvetvictory.site is your one-stop
   destination for a world of tooling! We don't just offer a vast array of online tools;
    we also recommend fantastic tool applications.Explore a diverse selection of free online tools, 
    all of which can be easily downloaded on your mobile devices, be it Android, or tablet.Our commitment to 
    helping you discover your ideal tools is unwavering.We offer comprehensive tool descriptions and captivating 
    screenshots from app stores to assist you in making your tooling choices.Plus, our download links are seamlessly
     connected to Google Play, guaranteeing you authentic and high- quality tooling experiences.At
      velvetvictory.site, we are on a mission to deliver enjoyable and immersive tooling adventures to players all 
      around the globe.Our ultimate aim is to assist you in finding your beloved tools and ensure you have an extraordinary
       time useing them.If you don't find the tools you adore, don't hesitate to reach out to us, and we'll go above and beyond
        to assist you. Company We are a company deeply passionate about the tooling industry, with a team that shares
         your enthusiasm for tools. velvetvictory.site was established in 2023, and we are continuously enhancing
          our website to provide the finest tooling encounters for our users. For more information, please drop us a line at alana@asking.media.  </p>


</div>


<div class="bottom-btn">
  <a href="javascript:;" @click="goText('/#/privacy')">Privacy Policy</a>
  <a @click="goText('/#/terms')" href="javascript:;">Terms-of Service</a>
  <a style="border-right:none" href="mailto:asking@asking.media">Contact Us</a>
</div>

  </div>
</template>
  
<script>
import   {  getDataList }  from "../../data/gameData_19"
export default {
  name: "HelloWorld",
  data(){
    return{
      dataList: getDataList(),
      gameList1:null,
      fullscreenLoading:false,
    }

  },
  props: {
    msg: String,
  },

  created(){
    window.scrollTo(0, 0);
    this.gameList1 = this.dataList

  },
    mounted(){
    // 页面加载完毕后滚动到顶部


   if (localStorage.getItem('Ifgoogl') != 'false') {
 // this.loadAds()
}
  },
  methods:{


goText(value){
   window.location.href = value
},
   openFullScreen1() {

window.location.href = `/#/list`
 

               
        
      },




    goIndex(){

        window.location.href = `/`


},

 loadAds() {
      // 动态插入 Google Ads 代码
      const script = document.createElement('script');
      script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6372117437285218";
      script.crossorigin = "anonymous"
      script.async = true;
      document.head.appendChild(script);

  script.onload = () => {
    // 等待广告脚本加载完成后调用 adsbygoogle.push()
    this.insertAd();
  };

  // 插入广告的函数
  this.insertAd = () => {
    // 插入第一个广告
    this.$nextTick(() => {
      const adDiv1 = this.$refs.ads1;
      adDiv1.innerHTML = `
        <ins class="adsbygoogle"
     style="display:inline-block;width:300px;height:250px"
     data-ad-client="ca-pub-6372117437285218"
     data-ad-slot="5463706596"></ins>
      `;
      // 只有第一个广告位才调用 push()
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    });

    // 插入第二个广告
    this.$nextTick(() => {
      const adDiv2 = this.$refs.ads2;
      adDiv2.innerHTML = `
       <ins class="adsbygoogle"
     style="display:inline-block;width:300px;height:250px"
     data-ad-client="ca-pub-6372117437285218"
     data-ad-slot="8257029502"></ins>
      `;
      // 只有第二个广告位才调用 push()
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    });



  };

    },

    
swiperList(value) {
  // 在回调函数中使用数据
  var dataCopy = this.dataList.map(element => element);
  var arrNew = [];

  for (var i = 0; i < value; i++) {
    var _num = Math.floor(Math.random() * dataCopy.length);
    var mm = dataCopy[_num];
    // 从复制的数组中移除已选择的元素
    dataCopy.splice(_num, 1);
    arrNew.push(mm);
  }
 
  return arrNew;

  // 这里可以进行后续的同步操作
},


goDetail(value){
   window.location.href = `/#/detail?id=${value.id}`
       
  // this.$router.push({path:`/detail?id=${value.id}`})
  

},

}
};


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.hello{
    background: #0d0821;
}
.head {
    padding: 20px;
    display: flex;
    min-height: 30px;
    align-items: center;
    justify-content: space-between;
.home{
  width: 12%;
}
.logo1{
       width: 70%;

}
}
.gameList{
    margin: auto;
    width: 100%;
    
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
      .game_itme{
        width: 59%;
        margin-bottom: 15px;

        .game_itme_url{
          width: 100%;
          img{
            border-radius: 24px;
            width: 100%;
            height: 100%;
          }
        }
        .game_itme_url2{
              width: 30%;
          img{
            border-radius: 24px;
            width: 100%;
            height: 100%;
          }
        }
      }
       .game_itme1{
        width: 29%;
        margin-bottom: 15px;

        .game_itme_url{
          width: 100%;
          img{
            border-radius: 24px;
            width: 100%;
            height: 100%;
          }
        }
        .game_itme_url2{
          img{
            border-radius: 24px;
            width: 100%;
            height: 100%;
          }
        }
      }
}
.gameList_te{
    margin: auto;
    width: 100%;
    
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
      .game_itme{
        width: 28%;
        margin-bottom: 15px;

        .game_itme_url{
          width: 100%;
          img{
            border-radius: 24px;
            width: 100%;
            height: 100%;
          }
        }
      }

}

.ads{
  width: 100%;
  min-height: 200px;
}
.anchor{
    width: 100%;
  height: 200px;
}

.About{
    margin-top: 15px;
    text-align: start;
    padding: 20px;
    background: #000000;
    color: white;
h2{
  text-align: center;
}
}
.bottom-btn{
      background: #000000;
    height: 40px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}
a{
      color: #fff;
    font-size: 16px;
        text-decoration: none;
    font-weight: 600;
    border-right: 2px solid #fff;
    padding: 4px;
}
.el-icon-s-home{
       font-size: 3rem;
    color: #ffffff;
}
.el-icon-menu{
     font-size: 3rem;
  color: #ffffff;
}

@media (max-width: 368px) {
  .game_text {
    font-size: 2vw; /* 移动端设备上可以增加文字大小 */
  }
  .game_name{
    font-size: 2vw; /* 移动端设备上可以增加文字大小 */
  }
    .play{
    font-size: 2vw; 
  }
    .el-breadcrumb{
     font-size: 4vw; 
  }
  .el-icon-menu{
    font-size: 4vw; 
  }
  .el-icon-s-home{
     font-size: 4vw;
  }
}

@media (max-width: 668px) {
  .game_text {
    font-size: 3vw; /* 移动端设备上可以增加文字大小 */
  }
  .game_name{
    font-size: 3vw; /* 移动端设备上可以增加文字大小 */
  }
    .play{
    font-size: 3vw; 
  }
    .el-breadcrumb{
     font-size: 3vw; 
  }
    .el-icon-menu{
    font-size: 3vw; 
  }
    .el-icon-s-home{
     font-size: 3vw;
  }
}


@media (max-width: 768px) {
  .game_text {
    font-size: 4vw; /* 移动端设备上可以增加文字大小 */
  }
  .game_name{
    font-size: 4vw; /* 移动端设备上可以增加文字大小 */
  }
    .play{
    font-size: 4vw; 
  }
    .el-breadcrumb{
     font-size: 4vw; 
  }
    .el-icon-menu{
    font-size: 4vw; 
  }
      .el-icon-s-home{
     font-size: 4vw;
  }
}


@media (max-width: 900px) {
  .game_text {
    font-size: 4vw; /* 移动端设备上可以增加文字大小 */
  }
  .game_name{
    font-size: 4vw; /* 移动端设备上可以增加文字大小 */
  }
    .play{
    font-size: 4vw; 
  }
    .el-breadcrumb{
     font-size: 4vw; 
  }
    .el-icon-menu{
    font-size: 4vw; 
  }
      .el-icon-s-home{
     font-size: 4vw;
  }
}


@media (max-width: 1000px) {
  .game_text {
    font-size: 4vw; /* 移动端设备上可以增加文字大小 */
  }
  .game_name{
    font-size: 4vw; /* 移动端设备上可以增加文字大小 */
  }
    .play{
    font-size: 4vw; 
  }
  .el-breadcrumb{
     font-size: 4vw; 
  }
    .el-icon-menu{
    font-size: 9vw; 
  }
      .el-icon-s-home{
     font-size: 9vw;
  }
}


@media (min-width: 1200px) {
  .game_text {
    font-size: 2vw; /* 在PC端显示时调整文字大小 */
  }
    .game_name{
    font-size: 2vw; /* 移动端设备上可以增加文字大小 */
  }
  .play{
    font-size: 2vw; 
  }
    .el-icon-menu{
    font-size: 7vw; 
  }
      .el-icon-s-home{
     font-size: 7vw;
  }
}


</style>
